interface StopIconProps {
  className?: string;
  color?: string;
  size?: "base" | "xs" | "sm" | "md" | "lg" | "xl";
}

export const StopIcon = ({
  className = "",
  color = "currentColor",
  size = "md",
}: StopIconProps) => {
  const sizeClasses = {
    base: "w-5 h-5",
    xs: "w-4 h-4",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-5.5 h-5.5",
    xl: "w-9 h-9",
  };

  return (
    <div className="icon stop-icon" >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill={color}
        className={`${sizeClasses[size]} ${className}`}
        aria-hidden="true"
      >
        <rect x="0" y="0" width="24" height="24" rx="1.5" />
      </svg>
    </div>
  );
};
export default StopIcon;

